import { createContext } from 'react';
import { QUERY_KEYS_VEHICLES, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const RankingsChartsDataContext = createContext();

const RankingsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_RANKINGS_POLICE_STATION,
            url: 'governanceroom/securitydashboard/vehicles/rankings/byPoliceStation'
        },
        filterParams
    );

    const rankByDepartment = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_RANKINGS_DEPARTMENT,
            url: 'governanceroom/securitydashboard/vehicles/rankings/byDepartment'
        },
        filterParams
    );

    const rankBySectional = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_RANKINGS_SECTIONAL,
            url: 'governanceroom/securitydashboard/vehicles/rankings/bySectional'
        },
        filterParams
    );

    const rankByCity = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_RANKINGS_CITY,
            url: 'governanceroom/securitydashboard/vehicles/rankings/byCity'
        },
        filterParams
    );

    const rankByNeighbourhood = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_RANKINGS_NEIGHBOURHOOD,
            url: 'governanceroom/securitydashboard/vehicles/rankings/byNeighborhood'
        },
        filterParams
    );

    const rankByYear = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_RANKINGS_YEAR,
            url: 'governanceroom/securitydashboard/vehicles/rankings/year'
        },
        filterParams
    );

    const rankByVehicleType = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_RANKINGS_VEHICLE_TYPE,
            url: 'governanceroom/securitydashboard/vehicles/rankings/vehicleType'
        },
        filterParams
    );

    const rankByBrand = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_RANKINGS_VEHICLE_BRAND,
            url: 'governanceroom/securitydashboard/vehicles/rankings/brand'
        },
        filterParams
    );


    const chartData = {
        byPoliceStation: data || [],
        byDepartment: rankByDepartment.data || [],
        bySectional: rankBySectional.data || [],
        byCity: rankByCity.data || [],
        byNeighbourhood: rankByNeighbourhood.data || [],
        byYear: rankByYear.data || [],
        byVehicleType: rankByVehicleType.data || [],
        byBrand: rankByBrand.data || [],
    }

    return (
        <RankingsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RankingsChartsDataContext.Provider>
    );
};

export default RankingsChartsDataProvider;
